import classNames from "classnames";
import { Link } from "react-router-dom";
import styles from "./style.module.scss";

interface CustomNotificationButtonProps {
  Icon: React.ReactNode;
  count?: number;
  onClick?: () => void;
  to?: string;
  className?: string;
  dotClassName?: string;
}

const CustomNotificationButton = ({
  Icon,
  count,
  onClick,
  to,
  className,
  dotClassName,
}: CustomNotificationButtonProps) => {
  const hasCount = count !== undefined && count > 0;
  const iconWithRing = (
    <span
      className={classNames(
        styles.bellIconWrapper,
        hasCount && styles.bellIconRing,
      )}
    >
      {Icon}
    </span>
  );

  const content = (
    <div className={classNames(styles.notificationIcon, className, "relative")}>
      {iconWithRing}
      {hasCount && (
        <span
          className={classNames(
            styles.notificationDot,
            dotClassName,
            "absolute",
          )}
        >
          {count}
        </span>
      )}
    </div>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={classNames(className || styles.notificationIcon)}
      >
        <div className="relative">
          {iconWithRing}
          {hasCount && (
            <span
              className={classNames(
                dotClassName || styles.notificationDot,
                "absolute -top-1 -right-0.5",
              )}
            >
              {count}
            </span>
          )}
        </div>
      </Link>
    );
  }

  if (onClick) {
    return (
      <div onClick={onClick} style={{ cursor: "pointer" }}>
        {content}
      </div>
    );
  }

  return content;
};

export default CustomNotificationButton;
